
import { TdsTextField } from '@scania/tegel-react';
import { modelDropdownList, persistDropdownList } from '../../helpers/genericDropdownList';
import { getDisplayValueForTextFields } from '../../helpers/getDisplayValue';
import { useContext } from 'react';
import { UserActionContext } from '../../AppContext';
import { isReadOnly } from '../../helpers/isReadOnly';
import { isNotUpdateable } from '../../helpers/isNotUpdateable';
import { observer } from 'mobx-react';
import GenericDropdown from '../GenericDropdown/GenericDropdown';
import './Trigger.scss';
import TextField from '../TextField/TextField';

interface TriggerProps {
    variableData?: VariableDetail
    isEditor: boolean
}
const Trigger = ({ variableData, isEditor }: TriggerProps) => {
    const { action, updateWithVersion } = useContext(UserActionContext);

    return (
        <>
            <div className="tds-row tds-u-mt2">
                <div className="tds-col-sm-4 tds-col-xs-4">
                    <TextField
                        label="Unit"
                        size="md"
                        modeVariant='secondary'
                        label-position="outside"
                        value={getDisplayValueForTextFields(variableData?.unit, action)}
                        readOnly={isReadOnly(isEditor, action) || isNotUpdateable(action, 'Unit', updateWithVersion)}
                        placeholder='Enter unit of measurement'
                        dataFieldName="unit"
                    />
                </div>
                <div className="tds-col-sm-4 tds-col-xs-4">
                    {/* //TODO: Currently, the API does not provide any data or at least an attribute. Once the API data is received, it needs to be implemented properly */}
                    {isReadOnly(isEditor, action) || isNotUpdateable(action, 'Mode', updateWithVersion) ?
                        <TdsTextField
                            type="text"
                            size="md"
                            state="default"
                            modeVariant="secondary"
                            label="Mode *"
                            labelPosition="outside"
                            readOnly={true}
                            value={getDisplayValueForTextFields(variableData?.mode, action)}>
                        </TdsTextField>
                        : <GenericDropdown
                            label="Mode *"
                            labelPosition="outside"
                            placeholder="Select mode"
                            size="md"
                            modeVariant="secondary"
                            openDirection="down"
                            defaultValue={variableData?.mode}
                            required="This field is required!"
                            listData={modelDropdownList}
                            dataFieldName='mode'
                        />
                    }
                </div>
                <div className="tds-col-sm-4 tds-col-xs-4">
                    {/* //TODO: Currently, the trigger related to this field is available in API and populate this attribute ecause of that,But  we need to get a final decision from the API team on whether to keep this field or not. */}
                    {isReadOnly(isEditor, action) || isNotUpdateable(action, 'Persist', updateWithVersion) ?
                        <TdsTextField
                            type="text"
                            size="md"
                            state="default"
                            modeVariant="secondary"
                            label="Persist *"
                            labelPosition="outside"
                            readOnly={true}
                            value={getDisplayValueForTextFields(variableData?.persist, action)}>
                        </TdsTextField>
                        : <GenericDropdown
                            label="Persist"
                            labelPosition="outside"
                            placeholder="Select a persist value"
                            size="md"
                            modeVariant="secondary"
                            openDirection="down"
                            defaultValue={variableData?.persist?.toString()}
                            listData={persistDropdownList}
                            dataFieldName='persist'
                        />
                    }
                </div>
            </div>
        </>
    );
};

export default observer(Trigger);